import $ from "jquery";

// $(()=>{
//     $("#recipe_premium").on('change', function(e){
//         $(this).attr('value', this.value ? false : true)
//     })
// });